import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import logo from "../assets/images/asset-planet-background.png";
import logoDark from "../assets/images/logodark.png";
import logout from "../assets/SVGs/updated-sidebar-icons/new-dashboard-sidebar-icons_New/logout.png";
import logoutWhite from "../assets/images/Sidebar_Icons/ZLOGOUT.png";
import dashboard2 from "../assets/images/sidebar/clientinfowhite.png";
import { resetStateProperties } from "../redux/slices/propertiesSlice";
import { resetStateRooms } from "../redux/slices/roomsSlice";
import { resetStateItems } from "../redux/slices/itemsSlice";
import { sideItemsClient } from "./SidebarConstants";
import SidebarMenu from "./SidebarMenu";
import SidebarSubMenu from "./SidebarSubMenu";
import { useTheme } from "../utils/ThemeContext";
import { resetStateChat,setAccpetedUsers,setMessagesList,setOnlineUsersList,setUnReadCount,setUnseenMessages } from "../redux/slices/chatSlice";
import { closeWebsocket } from "../utils/websocketConnect";

const Sidebar = () => {
  const { setTheme, theme } = useTheme();
  const [isMenuOpened, setisMenuOpened] = useState(true);
  const [accessId, setAccessId] = useState("");
  const [white, setWhite] = useState("");

  const [classNav, setClassNav] = useState("274px");

  const activated = useSelector(
    (state) => state.rootReducer.loginUser.activated
  );
  const [defaultValueName, setDefaultValueName] = useState("Me");
  const [userRoles, setUserRoles] = useState("");
  const [userss, setUserss] = useState("");
  const [active, setActive] = useState();
  const location = useLocation();
  const dispatch = useDispatch();

  const history = useHistory();

  useEffect(() => {
    // Perform localStorage action
    let userRole1 = "";
    let users1 = "";
    try {
      userRole1 =
        localStorage.getItem("role") != "undefined" &&
        JSON.parse(localStorage.getItem("role") || null);
      users1 =
        localStorage.getItem("delegateUsers") != "undefined" &&
        JSON.parse(localStorage.getItem("delegateUsers") || null);
      setUserRoles(userRole1);
      setUserss(users1);
      if (localStorage.getItem("accessId")) {
        const defaultValue =
          users1 &&
          users1.filter((item) => item.id == localStorage.getItem("accessId"));
        setDefaultValueName(defaultValue[0].userName);
      } else {
        setDefaultValueName("Me");
      }
    } catch (error) {
      console.log("error", error);
    }
  }, [activated, accessId]);
  const mouseHandlerEnter = () => {
    setClassNav("540px");
  };
  const mouseHandlerLeave = () => {
    setClassNav("274px");
  };
  const toggleMenu = (e) => {
    e.preventDefault();
    // this.setState({ isMenuOpened: !this.state.isMenuOpened });
    setisMenuOpened(!isMenuOpened);
  };
  const signOut = (e) => {
    // e.preventDefault();
    setTheme("light");
    dispatch(resetStateProperties());
    dispatch(resetStateRooms());
    dispatch(resetStateItems());
    dispatch(resetStateChat());
    dispatch(setUnReadCount(0));
    dispatch(setUnseenMessages([]));
    dispatch(setAccpetedUsers([]));
    dispatch(setMessagesList([]));
    dispatch(setOnlineUsersList([]));

    closeWebsocket();
    localStorage.removeItem("userLoginToken");
    localStorage.removeItem("role");
    localStorage.removeItem("delegateUsers");
    localStorage.removeItem("otp");
    localStorage.removeItem("User");
    localStorage.removeItem("fields");
    localStorage.removeItem("accessId");
    localStorage.removeItem("duplicateRole");
    localStorage.removeItem("profile");
    localStorage.removeItem("permissionState");
    localStorage.removeItem("userName");
    localStorage.clear();
  };

  return (
    <div className="left-side-menu" style={{ background: theme === "dark" ? "#232323" : "white",}}>
      <div
        style={{
          height: "70px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <span className="left-side-collapse-icon-custom">
          <img
            src={theme === "dark" ? logoDark : logo}
            className="bg-logo"
            style={{ width: "85%", height: "32.4px" }}
          />
        </span>
      </div>
      <div id="sidebar-menu" className="active">
        <ul className="metismenu in nav" id="nav" style={{ width: classNav }}>
          {sideItemsClient.map((item, index) => (
            <li
              key={index}
              style={{
                display: "flex",
                flexDirection: "row",
                height: "fit-content",
                width: "fit-content",
              }}
              onMouseEnter={mouseHandlerEnter}
              onMouseLeave={mouseHandlerLeave}
            >
              <SidebarMenu item={item} />
              {item.subNav && (
                <ul style={{ padding: "10px", marginTop: "8px",background: theme === "dark" ? "#232323" : "white", }}>
                  {item.subNav.map((item, index) => (
                    <li key={index} style={{}}>
                      <SidebarSubMenu item={item} />
                    </li>
                  ))}
                </ul>
              )}
            </li>
          ))}

          <li
            onMouseLeave={() => setWhite("")}
            onMouseOver={() => {
              setWhite("white");
            }}
          >
            <Link onClick={signOut} to="/login">
              <div className="side-menu-block1 hoverIconLogout">
                <div className="">
                  <img
                    src={logoutWhite}
                    className={white === "white" || theme === "dark" ? "img-icon" : "img-icon-dark"}
                  />
                  <span style={{ paddingLeft: "10px",color: theme === "dark" ? "white" : "" }} className="">
                    Logout
                  </span>
                </div>
              </div>
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar;
